// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-gray-100: hsl(220, 12%, 98%);
  --color-gray-200: hsl(220, 12%, 90%);
  --color-gray-300: hsl(220, 12%, 85%);
  --color-gray-400: hsl(220, 12%, 65%);
  --color-gray-500: hsl(220, 12%, 45%);

  --color-dark-100: hsl(240, 10%, 15%);
  --color-dark-200: hsl(240, 10%, 12%);
  --color-dark-300: hsl(240, 10%, 9%);
  --color-dark-400: hsl(240, 10%, 6%);
  --color-dark-500: hsl(240, 10%, 3%);

  --color-blue-100: hsl(217, 80%, 65%);
  --color-blue-200: hsl(217, 80%, 60%);
  --color-blue-300: hsl(217, 80%, 55%);
  --color-blue-400: hsl(217, 80%, 50%);
  --color-blue-500: hsl(217, 80%, 45%);

  --shadow-small: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,
      rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
  --shadow-medium: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
      rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  --shadow-large: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  --shadow-extra: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
      rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
}

*,
*::before,
*::after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  list-style: none;
  list-style-type: none;
  text-decoration: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

html {
  font-size: 100%;
  box-sizing: inherit;
  scroll-behavior: smooth;
  height: -webkit-fill-available;
}

body {
  font-family: "Roboto", ui-sans-serif, sans-serif;
  font-size: clamp(1rem, 2vw, 1.125rem);
  font-weight: 400;
  line-height: 1.5;
  color: var(--color-gray-100);
  background-color: var(--color-dark-500);
}

main,
section {
  overflow: hidden;
}

a,
button {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  border: none;
  outline: none;
  color: inherit;
  background: unset;
}

h1,
h2,
h3,
h4,
h5 {
  font-family: inherit;
  line-height: 1.25;
  text-wrap: balance;
  word-wrap: break-word;
}

p,
li {
  font-family: inherit;
  line-height: 1.5;
  text-wrap: pretty;
  word-wrap: break-word;
}

img,
svg,
picture {
  max-width: 100%;
  height: auto;
  vertical-align: middle;
  object-fit: cover;
  background-size: cover;
  background-repeat: no-repeat;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: -moz-crisp-edges;
  image-rendering: crisp-edges;
}

.section {
  padding-block: 6rem 3rem;
}

.container {
  max-width: 75rem;
  height: auto;
  margin-inline: auto;
  padding-inline: 1.5rem;
}

.center {
  text-align: center;
  vertical-align: middle;
}

.truncate {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.title-small {
  font-family: inherit;
  font-size: clamp(1.75rem, 4vw, 2.35rem);
  font-weight: 700;
  line-height: 1.25;
}

.title-medium {
  font-family: inherit;
  font-size: clamp(2.15rem, 5vw, 3.15rem);
  font-weight: 700;
  line-height: 1.15;
}

.title-large {
  font-family: inherit;
  font-size: clamp(2.65rem, 6vw, 4rem);
  font-weight: 700;
  line-height: 1.15;
}

.text-small {
  font-family: inherit;
  font-size: 0.85rem;
  line-height: 1.5;
}

.text-base {
  font-family: inherit;
  font-size: 1rem;
  line-height: 1.5;
  text-align: justify;
}

.text-medium {
  font-family: inherit;
  font-size: 1.15rem;
  line-height: 1.5;
}

.text-large {
  font-family: inherit;
  font-size: 1.3rem;
  line-height: 1.5;
}

.text-upper {
  text-transform: uppercase;
}

.text-lower {
  text-transform: lowercase;
}

.text-capital {
  text-transform: capitalize;
}

.font-light {
  font-weight: 300;
}

.font-normal {
  font-weight: 400;
}

.font-medium {
  font-weight: 500;
}

.font-semi {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.btn {
  display: inline-flex;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  align-items: center;
  white-space: nowrap;
  text-align: center;
  justify-content: center;
  vertical-align: middle;
  column-gap: 0.35rem;
  padding-block: 0.5rem;
  padding-inline: 1.25rem;
  border-radius: 3rem;
  transition: all 0.25s ease;
}

.btn-primary {
  color: var(--color-gray-100);
  background-color: var(--color-blue-300);
  box-shadow: var(--shadow-medium);
}

.btn-neutral {
  color: var(--color-dark-300);
  background-color: var(--color-gray-100);
  box-shadow: var(--shadow-medium);
}

.btn-darken {
  color: var(--color-gray-100);
  background-color: var(--color-dark-100);
  box-shadow: var(--shadow-medium);
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: auto;
  margin: 0 auto;
  transition: all 0.35s ease;
  background-color: #000 ; /* Added black background */
   
}

.header.on-scroll {
  background-color: #000 !important;
  box-shadow: var(--shadow-medium);
}

.navbarCustom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: baseline;
  column-gap: 1rem;
  width: 100%;
  height: 4rem;
  margin-inline: auto;
  background-color: #000 ; /* Add black background to navbar */
 
}

.brand {
  font-family: inherit;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.5;
  text-transform: uppercase;
  color: var(--color-gray-100);
}

.menu {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  height: auto;
  overflow: hidden;
  padding-block: 4rem;
  background-color: var(--color-dark-400);
  box-shadow: var(--shadow-medium);
  transition: all 0.3s ease;
}

.menu.is-active {
  top: 0;
  left: 0;
}

.menu-inner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 1.25rem;
}

.menu-link {
  font-family: inherit;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  text-transform: uppercase;
  color: var(--color-gray-100);
}

.menu-block {
  margin-left: auto;
}


/* Contact section */

.about-section {
  padding: 4rem 0;
  background-color: #f9f9f9;
}


/* Contact section */

.contact-section {
  padding: 4rem 0;
  background-color: #000;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.form-field {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.form-field label {
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.form-field input,
.form-field textarea {
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
}

.btn-primary {
  align-self: flex-start;
  padding: 0.75rem 1.5rem;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #0056b3;
}







@media screen and (min-width: 48rem) {
  .menu {
    position: relative;
    top: initial;
    width: auto;
    padding: 0;
    margin-left: auto;
    background: unset;
    box-shadow: unset;
    transition: unset;
  }
  
  .menu-inner {
    display: flex;
    flex-direction: row;
    column-gap: 2rem;
    margin-inline: auto;
  }
  
  .menu-link {
    text-transform: capitalize;
  }
  
  .menu-block {
    margin-left: 2rem;
  }
}

.burger {
  cursor: pointer;
  position: relative;
  display: block;
  order: -1;
  z-index: 10;
  width: 1.5rem;
  height: 1rem;
  -webkit-user-select: none;
          user-select: none;
  visibility: visible;
}

@media screen and (min-width: 48rem) {
  .burger {
    display: none;
    visibility: hidden;
  }
}

.burger-line {
  position: absolute;
  display: block;
  left: 0;
  opacity: 1;
  width: 100%;
  height: 2px;
  background-color: var(--color-gray-100);
  transition: all 0.25s ease;
}

.burger-line:nth-child(1) {
  top: 0px;
}

.burger-line:nth-child(2) {
  top: 0.5rem;
  width: 70%;
}

.burger-line:nth-child(3) {
  top: 1rem;
}

.burger.is-active .burger-line:nth-child(1) {
  top: 0.5rem;
  transform: rotate(135deg);
}

.burger.is-active .burger-line:nth-child(2) {
  left: -1rem;
  opacity: 0;
}

.burger.is-active .burger-line:nth-child(3) {
  top: 0.5rem;
  transform: rotate(-135deg);
}

.overlay {
  position: fixed;
  display: none;
  inset: 0;
  z-index: -2;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background-color: black;
  transition: all 0.3s ease;
}

.overlay.is-active {
  display: block;
}

.banner-column {
  position: relative;
  display: grid;
  align-items: center;
  row-gap: 3rem;
  column-gap: 2rem;
}

@media screen and (min-width: 48rem) {
  .banner-column {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    justify-content: center;
    margin-top: 4rem;
  }
}

@media screen and (min-width: 64rem) {
  .banner-column {
    grid-template-columns: 1fr max-content;
    column-gap: 4rem;
  }
}

.banner-image {
  display: block;
  max-width: 16rem;
  height: auto;
  object-fit: cover;
  justify-self: center;
}

@media screen and (min-width: 48rem) {
  .banner-image {
    max-width: 20rem;
    order: 1;
  }
}

@media screen and (min-width: 64rem) {
  .banner-image {
    max-width: 24rem;
    margin-right: 5rem;
  }
}

.banner-inner {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  row-gap: 1.5rem;
}

.banner-link {
  position: absolute;
  display: grid;
  top: 30%;
  right: 1.5rem;
  justify-items: center;
  row-gap: 0.5rem;
  visibility: hidden;
}

@media screen and (min-width: 64rem) {
  .banner-link {
    visibility: visible;
  }
}

.banner-link > * {
  font-size: 1.25rem;
  line-height: inherit;
  color: var(--color-gray-100);
}

.banner-link::before,
.banner-link::after {
  content: "";
  position: absolute;
  width: 4rem;
  height: 1.5px;
  transform: rotate(90deg);
  background: var(--color-gray-100);
}

.banner-link::before {
  top: -3rem;
}

.banner-link::after {
  bottom: -3rem;
}`, "",{"version":3,"sources":["webpack://./src/components/HeroSection.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;;EAEnC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;;EAEpC;yCACuC;EACvC;0CACwC;EACxC;0CACwC;EACxC;4CAC0C;AAC5C;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;EAChD,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;EAKE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,0CAA0C;EAC1C,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,uBAAuB,EAAE,2BAA2B;;AAEtD;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB,EAAE,mCAAmC;;AAE9D;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,MAAM;EACN,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;;AAGA,oBAAoB;;AAEpB;EACE,eAAe;EACf,yBAAyB;AAC3B;;;AAGA,oBAAoB;;AAEpB;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;;;;;;AAQA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,WAAW;EACX,aAAa;EACb,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,UAAU;EACV,WAAW;EACX,WAAW;EACX,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;IAChD,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf","sourcesContent":[":root {\n  --color-gray-100: hsl(220, 12%, 98%);\n  --color-gray-200: hsl(220, 12%, 90%);\n  --color-gray-300: hsl(220, 12%, 85%);\n  --color-gray-400: hsl(220, 12%, 65%);\n  --color-gray-500: hsl(220, 12%, 45%);\n\n  --color-dark-100: hsl(240, 10%, 15%);\n  --color-dark-200: hsl(240, 10%, 12%);\n  --color-dark-300: hsl(240, 10%, 9%);\n  --color-dark-400: hsl(240, 10%, 6%);\n  --color-dark-500: hsl(240, 10%, 3%);\n\n  --color-blue-100: hsl(217, 80%, 65%);\n  --color-blue-200: hsl(217, 80%, 60%);\n  --color-blue-300: hsl(217, 80%, 55%);\n  --color-blue-400: hsl(217, 80%, 50%);\n  --color-blue-500: hsl(217, 80%, 45%);\n\n  --shadow-small: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,\n      rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;\n  --shadow-medium: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,\n      rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\n  --shadow-large: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,\n      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;\n  --shadow-extra: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,\n      rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;\n}\n\n*,\n*::before,\n*::after {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  list-style: none;\n  list-style-type: none;\n  text-decoration: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\nhtml {\n  font-size: 100%;\n  box-sizing: inherit;\n  scroll-behavior: smooth;\n  height: -webkit-fill-available;\n}\n\nbody {\n  font-family: \"Roboto\", ui-sans-serif, sans-serif;\n  font-size: clamp(1rem, 2vw, 1.125rem);\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--color-gray-100);\n  background-color: var(--color-dark-500);\n}\n\nmain,\nsection {\n  overflow: hidden;\n}\n\na,\nbutton {\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n  border: none;\n  outline: none;\n  color: inherit;\n  background: unset;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  font-family: inherit;\n  line-height: 1.25;\n  text-wrap: balance;\n  word-wrap: break-word;\n}\n\np,\nli {\n  font-family: inherit;\n  line-height: 1.5;\n  text-wrap: pretty;\n  word-wrap: break-word;\n}\n\nimg,\nsvg,\npicture {\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n  object-fit: cover;\n  background-size: cover;\n  background-repeat: no-repeat;\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: -moz-crisp-edges;\n  image-rendering: crisp-edges;\n}\n\n.section {\n  padding-block: 6rem 3rem;\n}\n\n.container {\n  max-width: 75rem;\n  height: auto;\n  margin-inline: auto;\n  padding-inline: 1.5rem;\n}\n\n.center {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.truncate {\n  display: -webkit-box;\n  line-clamp: 2;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.title-small {\n  font-family: inherit;\n  font-size: clamp(1.75rem, 4vw, 2.35rem);\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.title-medium {\n  font-family: inherit;\n  font-size: clamp(2.15rem, 5vw, 3.15rem);\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.title-large {\n  font-family: inherit;\n  font-size: clamp(2.65rem, 6vw, 4rem);\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.text-small {\n  font-family: inherit;\n  font-size: 0.85rem;\n  line-height: 1.5;\n}\n\n.text-base {\n  font-family: inherit;\n  font-size: 1rem;\n  line-height: 1.5;\n  text-align: justify;\n}\n\n.text-medium {\n  font-family: inherit;\n  font-size: 1.15rem;\n  line-height: 1.5;\n}\n\n.text-large {\n  font-family: inherit;\n  font-size: 1.3rem;\n  line-height: 1.5;\n}\n\n.text-upper {\n  text-transform: uppercase;\n}\n\n.text-lower {\n  text-transform: lowercase;\n}\n\n.text-capital {\n  text-transform: capitalize;\n}\n\n.font-light {\n  font-weight: 300;\n}\n\n.font-normal {\n  font-weight: 400;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-semi {\n  font-weight: 600;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.btn {\n  display: inline-flex;\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  align-items: center;\n  white-space: nowrap;\n  text-align: center;\n  justify-content: center;\n  vertical-align: middle;\n  column-gap: 0.35rem;\n  padding-block: 0.5rem;\n  padding-inline: 1.25rem;\n  border-radius: 3rem;\n  transition: all 0.25s ease;\n}\n\n.btn-primary {\n  color: var(--color-gray-100);\n  background-color: var(--color-blue-300);\n  box-shadow: var(--shadow-medium);\n}\n\n.btn-neutral {\n  color: var(--color-dark-300);\n  background-color: var(--color-gray-100);\n  box-shadow: var(--shadow-medium);\n}\n\n.btn-darken {\n  color: var(--color-gray-100);\n  background-color: var(--color-dark-100);\n  box-shadow: var(--shadow-medium);\n}\n\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  width: 100%;\n  height: auto;\n  margin: 0 auto;\n  transition: all 0.35s ease;\n  background-color: #000 ; /* Added black background */\n   \n}\n\n.header.on-scroll {\n  background-color: #000 !important;\n  box-shadow: var(--shadow-medium);\n}\n\n.navbarCustom {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: baseline;\n  column-gap: 1rem;\n  width: 100%;\n  height: 4rem;\n  margin-inline: auto;\n  background-color: #000 ; /* Add black background to navbar */\n \n}\n\n.brand {\n  font-family: inherit;\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 1.5;\n  text-transform: uppercase;\n  color: var(--color-gray-100);\n}\n\n.menu {\n  position: fixed;\n  top: -100%;\n  left: 0;\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n  padding-block: 4rem;\n  background-color: var(--color-dark-400);\n  box-shadow: var(--shadow-medium);\n  transition: all 0.3s ease;\n}\n\n.menu.is-active {\n  top: 0;\n  left: 0;\n}\n\n.menu-inner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  row-gap: 1.25rem;\n}\n\n.menu-link {\n  font-family: inherit;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  text-transform: uppercase;\n  color: var(--color-gray-100);\n}\n\n.menu-block {\n  margin-left: auto;\n}\n\n\n/* Contact section */\n\n.about-section {\n  padding: 4rem 0;\n  background-color: #f9f9f9;\n}\n\n\n/* Contact section */\n\n.contact-section {\n  padding: 4rem 0;\n  background-color: #000;\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.form-field {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.form-field label {\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n}\n\n.form-field input,\n.form-field textarea {\n  padding: 0.75rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 1rem;\n}\n\n.btn-primary {\n  align-self: flex-start;\n  padding: 0.75rem 1.5rem;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.btn-primary:hover {\n  background-color: #0056b3;\n}\n\n\n\n\n\n\n\n@media screen and (min-width: 48rem) {\n  .menu {\n    position: relative;\n    top: initial;\n    width: auto;\n    padding: 0;\n    margin-left: auto;\n    background: unset;\n    box-shadow: unset;\n    transition: unset;\n  }\n  \n  .menu-inner {\n    display: flex;\n    flex-direction: row;\n    column-gap: 2rem;\n    margin-inline: auto;\n  }\n  \n  .menu-link {\n    text-transform: capitalize;\n  }\n  \n  .menu-block {\n    margin-left: 2rem;\n  }\n}\n\n.burger {\n  cursor: pointer;\n  position: relative;\n  display: block;\n  order: -1;\n  z-index: 10;\n  width: 1.5rem;\n  height: 1rem;\n  user-select: none;\n  visibility: visible;\n}\n\n@media screen and (min-width: 48rem) {\n  .burger {\n    display: none;\n    visibility: hidden;\n  }\n}\n\n.burger-line {\n  position: absolute;\n  display: block;\n  left: 0;\n  opacity: 1;\n  width: 100%;\n  height: 2px;\n  background-color: var(--color-gray-100);\n  transition: all 0.25s ease;\n}\n\n.burger-line:nth-child(1) {\n  top: 0px;\n}\n\n.burger-line:nth-child(2) {\n  top: 0.5rem;\n  width: 70%;\n}\n\n.burger-line:nth-child(3) {\n  top: 1rem;\n}\n\n.burger.is-active .burger-line:nth-child(1) {\n  top: 0.5rem;\n  transform: rotate(135deg);\n}\n\n.burger.is-active .burger-line:nth-child(2) {\n  left: -1rem;\n  opacity: 0;\n}\n\n.burger.is-active .burger-line:nth-child(3) {\n  top: 0.5rem;\n  transform: rotate(-135deg);\n}\n\n.overlay {\n  position: fixed;\n  display: none;\n  inset: 0;\n  z-index: -2;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  background-color: black;\n  transition: all 0.3s ease;\n}\n\n.overlay.is-active {\n  display: block;\n}\n\n.banner-column {\n  position: relative;\n  display: grid;\n  align-items: center;\n  row-gap: 3rem;\n  column-gap: 2rem;\n}\n\n@media screen and (min-width: 48rem) {\n  .banner-column {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    justify-content: center;\n    margin-top: 4rem;\n  }\n}\n\n@media screen and (min-width: 64rem) {\n  .banner-column {\n    grid-template-columns: 1fr max-content;\n    column-gap: 4rem;\n  }\n}\n\n.banner-image {\n  display: block;\n  max-width: 16rem;\n  height: auto;\n  object-fit: cover;\n  justify-self: center;\n}\n\n@media screen and (min-width: 48rem) {\n  .banner-image {\n    max-width: 20rem;\n    order: 1;\n  }\n}\n\n@media screen and (min-width: 64rem) {\n  .banner-image {\n    max-width: 24rem;\n    margin-right: 5rem;\n  }\n}\n\n.banner-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  row-gap: 1.5rem;\n}\n\n.banner-link {\n  position: absolute;\n  display: grid;\n  top: 30%;\n  right: 1.5rem;\n  justify-items: center;\n  row-gap: 0.5rem;\n  visibility: hidden;\n}\n\n@media screen and (min-width: 64rem) {\n  .banner-link {\n    visibility: visible;\n  }\n}\n\n.banner-link > * {\n  font-size: 1.25rem;\n  line-height: inherit;\n  color: var(--color-gray-100);\n}\n\n.banner-link::before,\n.banner-link::after {\n  content: \"\";\n  position: absolute;\n  width: 4rem;\n  height: 1.5px;\n  transform: rotate(90deg);\n  background: var(--color-gray-100);\n}\n\n.banner-link::before {\n  top: -3rem;\n}\n\n.banner-link::after {\n  bottom: -3rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
